import React, { useEffect } from 'react';
import useDebounce from '@/hooks/useDebounce';
import styles from './index.less';
import { TLang } from '@/utils/lang';

interface ILoadProps{
  clientDom:string, // 可视dom
  docuDom:string, //文档dom  文档高度。 此高度会大于 可视高度
  loadMore:()=>void,
  hasMore?:boolean,
  show?:boolean,
  text?:string,

}
let timer;
const PullLoad = (props:ILoadProps) => {
// 获取当前滚动条的位置
  const getScrollTop =() => {

    const scrollDom:any = document.querySelector(props.clientDom);// '.am-drawer-content'
    // 小米手机自带浏览器取值不准确，带小数，存在比正常值大、小一点的情况
    return Math.ceil(scrollDom?.scrollTop || 0);
  };
  // 获取当前可视范围的高度
  const getClientHeight =() => {
    var clientHeight = 0;

    // if (document.body.clientHeight && document.documentElement.clientHeight) {
    //     clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
    // }
    // else {
    //     clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
    // }
    const dom:any = document.querySelector(props.clientDom);

    return dom.clientHeight;
  };

  // 获取文档完整的高度
  const getScrollHeight = () => {
    const scrollDom:any = document.querySelector(props.docuDom); //.movieDetail
    return scrollDom&&scrollDom?.clientHeight;
  };
  const scrollHandle = () => {
    if(timer){
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      // 可视区域高度 + 卷去的高度 === 文档高度
      if(getClientHeight() + getScrollTop() >= getScrollHeight() && props.hasMore){
        props.loadMore&&props.loadMore();
      }
    }, 300);
  };

  useEffect(() => {
    const scrollDom:any = document.querySelector(props.clientDom); //.am-drawer-content 可视区域高度
    scrollDom?.addEventListener('scroll', scrollHandle);
    return () => {
      scrollDom?.removeEventListener('scroll', scrollHandle);
    };
  },);
  return <div className={styles.load}>
    {
      props.show? props.hasMore? <p>{TLang('加载中', 'home', false, false, null)}</p>:<p>{TLang('没有更多了', 'home', false, false, null)}</p>:null
    }
  </div>;
};
export default PullLoad;
/** <p>- 已经到底啦 -</p> */
